export default "__VITE_ASSET__vGUyZRXu__"